export function getWeekdayLabel(dateString, locale) {
    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) {
        return "";
    }

    return date.toLocaleDateString(locale, { weekday: "long" });
}

export function getMonthDayLabel(dateString, locale) {
    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) {
        return "";
    }

    return date.toLocaleDateString(locale, { month: "short", day: "numeric" });
}

export function formatPromptDateLabel(dateString, locale) {
    if (!dateString) return "";
    const date = new Date(dateString);
    if (Number.isNaN(date.getTime())) {
        return dateString;
    }

    const weekday = date.toLocaleDateString(locale, { weekday: "short" });
    const monthDay = date.toLocaleDateString(locale, { month: "short", day: "numeric" });
    return `${weekday}, ${monthDay}`;
}
